// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Container,
  Loader,
  Button,
  Grid,
  Form,
  Header,
  Label,
  Segment,
  Message
} from 'semantic-ui-react'
import fire from '../config/Fire'

export default class AccountSettings extends Component {
  constructor (props) {
    super(props)
    this.updateProfile = this.updateProfile.bind(this)
    this.state = {
      visible: true,
      loading: true,
      error: false,
      nameEdit: '',
      data: []
    }
  }

  componentDidMount = (event) => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        window.scrollTo(0, 0)

        this.setState({
          loggedIn: true,
          loading: false,
          ok: true,
          userEmail: user.email,
          userID: user.uid,
          photoURL: user.photoURL,
          user: user,
          email: user.email,
          displayName: user.displayName,
          emailVerified: user.emailVerified,
          accountType: user.providerData[0].providerId,
          createdAt: user.metadata.creationTime,
          lastSignIn: user.metadata.lastSignInTime
        })
        this.premium()
      } else {
        this.props.history.push(`/`)
      }
    })
  }

  premium = (e) => {
    this.setState({
      loading: true
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/premium/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: this.state.email
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.setState({ loading: false, data: json })
        if (json.code === 200) {
          this.setState({ free: false })
        } else {
          this.setState({ free: true })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  verifyEmail = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        if (user.emailVerified === false) {
          user
            .sendEmailVerification({
              url: 'https://murkstom.com'
            })
            .catch((error) => {
              console.log(error)
              this.setState({ error: error.message })
            })
          this.setState({ sentVerification: true })
        }
      } else {
        this.props.history.push(`/`)
      }
    })
  }

  updateProfile = () => {
    const self = this
    self.setState({ updating: true })
    let { nameEdit } = this.state
    var user = fire.auth().currentUser
    user
      .updateProfile({
        displayName: nameEdit
      })
      .then(function () {
        window.location.reload()
      })
      .catch(function (error) {
        self.setState({ error: error })
        console.log(error)
      })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render () {
    let {
      email,
      displayName,
      emailVerified,
      accountType,
      createdAt,
      lastSignIn,
      loading,
      error,
      sentVerification,
      updating,
      data
    } = this.state
    return (
      <Container className='masterdiv'>
        {!loading ? (
          <div>
            {!emailVerified && !sentVerification && (
              <div className='mb'>
                <Segment padded inverted>
                  <Grid columns='2' verticalAlign='middle'>
                    <Grid.Column>
                      <h3 style={{ color: '#fff' }}>Email not confirmed</h3>
                    </Grid.Column>
                    <Grid.Column textAlign='right'>
                      <Button
                        size='large'
                        disabled={sentVerification}
                        style={{ backgroundColor: '#E5E1DB', color: '#000' }}
                        onClick={this.verifyEmail}>
                        Verify
                      </Button>
                    </Grid.Column>
                  </Grid>
                </Segment>
              </div>
            )}
            {sentVerification && (
              <Segment padded>
                <h4>Waiting for confirmation.</h4>
              </Segment>
            )}
            {error && (
              <Message error size='large'>
                <b>{error}</b>
              </Message>
            )}

            <div className='screen-card'>
              <Segment basic>
                <Grid stackable verticalAlign='middle'>
                  <Grid.Column width='8'>
                    <div className='mbs'>
                      <h2>{displayName}</h2>
                      <Label size='small'>{email}</Label>
                    </div>
                    <Form>
                      <Form.Input
                        label='Display name'
                        type='text'
                        onChange={this.handleChange}
                        placeholder='John Doe'
                        name='nameEdit'
                      />
                      <Form.Button
                        fluid
                        disabled={error}
                        color='black'
                        loading={updating}
                        onClick={this.updateProfile}
                        content='Update'
                      />
                    </Form>
                  </Grid.Column>
                  <Grid.Column width='8'>
                    <Segment>
                      <Header as='h4'>
                        Last sign in
                        <Header.Subheader>{lastSignIn}</Header.Subheader>
                      </Header>
                    </Segment>
                    <Segment>
                      <Header as='h4'>
                        Created at
                        <Header.Subheader>{createdAt}</Header.Subheader>
                      </Header>
                    </Segment>
                    <Segment>
                      <Header as='h4'>
                        Account type
                        <Header.Subheader>{accountType}</Header.Subheader>
                      </Header>
                    </Segment>
                  </Grid.Column>
                </Grid>
              </Segment>
            </div>
            {data.code === 200 && (
              <div className='mt'>
                <Segment padded compact>
                  <p>
                    <b>subscription_id:</b> {data.ID}
                  </p>
                  <p>
                    <b>next_payment:</b> {data.next}
                  </p>
                  <div>
                    <Button
                      fluid
                      disabled={error}
                      basic
                      size='small'
                      color='red'
                      href={data.cancel_url}>
                      Cancel susbscription
                    </Button>
                  </div>
                </Segment>
              </div>
            )}
          </div>
        ) : (
          <div className='mt'>
            <Loader active inline='centered'>
              Loading...
            </Loader>
          </div>
        )}
      </Container>
    )
  }
}
